export enum ReservationInformationType {
  Phone,
  AddUpdateEmail,
  DeleteEmail,
  Address,
  ReservationLookupFailure,
  CtcmAdd,
  CtceAdd,
  CtcrAdd,
  CtcmRemove,
  CtceRemove,
  CtcrRemove,
  Unknown,
}
